import { render, staticRenderFns } from "./ActiveCalendarIcon.vue?vue&type=template&id=5bf15f24&scoped=true&"
import script from "./ActiveCalendarIcon.vue?vue&type=script&lang=js&"
export * from "./ActiveCalendarIcon.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCalendarIcon.vue?vue&type=style&index=0&id=5bf15f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf15f24",
  null
  
)

export default component.exports